import React, { useState, useRef, useEffect } from "react";
import "./style.scss";
import StatusBackground from "../StatusBackground";


const StatusSelector = ({ currentStatus, onStatusChange }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  // Available status options
  const statusOptions = [
    "New Task", 
    "In Progress", 
    "Completed", 
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleStatusClick = (status) => {
    onStatusChange(status);
    setIsDropdownOpen(false);
  };

  return (
    <div className="status-selector-container" ref={dropdownRef}>
      <div 
        className="status-selector-trigger"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <StatusBackground status={currentStatus} />
      </div>
      
      {isDropdownOpen && (
        <div className="status-dropdown">
          {statusOptions.map((status) => (
            <div 
              key={status} 
              className="status-option"
              onClick={() => handleStatusClick(status)}
            >
              <StatusBackground status={status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusSelector;